import { useMutation } from '@apollo/client';
import { Form, Input, Modal } from 'antd';
import { trim } from 'lodash';
import React, { useEffect, useRef } from 'react';
import { ADD_ENV } from '../graphql/Mutations';

const initialValues = {
  name: '',
  value: '',
  isPrivate: false,
};

export default function AddEnvModal({
  visible,
  setVisible,
  refetchEnvKeyValueData,
  selectedProjectTopics,
  sourceType,
  selectedTopics,
  selectedProject,
  environmentRefetch,
}) {
  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const [addEnv, { loading }] = useMutation(ADD_ENV, {
    onCompleted() {
      refetchEnvKeyValueData();
      environmentRefetch();
      setVisible(false);
      form?.resetFields();
    },
    onError() {},
  });

  const onFinish = (values) => {
    const value = values?.value?.toLowerCase().trim();
    addEnv({
      variables: {
        data: {
          envName: value,
          projectRefId: trim(selectedProject?.value),
          projectTopicId:
            sourceType === 'GITHUB'
              ? selectedTopics?.topicsData?.name
              : selectedProjectTopics,
          sourceType,
        },
      },
    });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event?.key === 'Enter' && visible) {
        event?.preventDefault();
        form?.submit();
      }
    };

    // eslint-disable-next-line no-undef
    document?.addEventListener('keydown', handleKeyDown);
    return () => {
      // eslint-disable-next-line no-undef
      document?.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);

  return (
    <Modal
      open={visible}
      centered
      title="Create a new ENV"
      onOk={() => {
        form?.submit();
      }}
      onCancel={() => {
        setVisible(false);
        form?.resetFields();
      }}
      okText="Add"
      okButtonProps={{ loading }}
      afterOpenChange={(open) => {
        if (open) {
          inputRef?.current?.focus();
        }
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Form.Item
          label="Enter ENV Value"
          name="value"
          rules={[
            { required: true, message: 'Please enter ENV value!' },
            {
              validator: (_, value) => {
                if (value && value?.trimStart() !== value) {
                  return Promise.reject(
                    new Error('Only spaces are not allowed!'),
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input ref={inputRef} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
